import axios from "axios";
import env from "@/configuration/env";
import store from "@/stores";

axios.interceptors.request.use((config) => {
  if (config.url.startsWith("/")) {
    // initialization
    config.baseURL = env.api_base_address;

    // axios 1.x: config.headers is an AxiosHeaders instance, no .post/.put/.common sub-objects
    if (["post", "put", "patch"].includes(config.method)) {
      config.headers.set("Content-Type", "application/json");
    }

    // JWT
    if (store.state.cognito.idToken) config.headers.set("Authorization", `Bearer ${store.state.cognito.idToken.jwtToken}`);
  }

  return config;
});

export default {
  init: async () => {},
};
